module.exports = __webpack_public_path__ + "img/23.36c54eb.png";